import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EventData } from '../providers/event';

@Pipe({
    name: 'staffConfigData'
})

export class StaffConfigDataipe implements PipeTransform {

    constructor(
        private eventData: EventData
    ) { }

    transform(value: string, clientId: string): Observable<any> {
        return this.eventData.getClientStaffsById(clientId, value);
    }
}


// WEBPACK FOOTER //
// ./src/pipes/staff-data-config.pipe.ts